import { eventsSender } from 'globalState/global-state.js';

export const changeFilter = ({ source, filterName, filterValue }) => {
    const isMobile = window.config.state.theme === 'mobile';
    const mobileSource = document.querySelector('#search-mobile-list')
        ? 'search'
        : 'good-list';
    const desktopSource = document.querySelector('#search-page')
        ? 'search'
        : 'good-list';
    const defaultSource = isMobile ? mobileSource : desktopSource;

    try {
        eventsSender('filter', 'filterChange', {
            source: source || defaultSource,
            filterName,
            filterValue,
        });
    } catch (err) {
        console.error(err);
    }
};
